<!--NOCH KEINE FUNKTION-->
<div class="version-selector-wrapper"></div>

<app-detail-display-document-list [fileIds]="fileIds" [dataType]="'CERTIFICATION'">
</app-detail-display-document-list>